import React from 'react';
import PropTypes from 'prop-types';

export default function Header({ className }) {
  return (
    <section>
      <div className={`d-xl-flex gap-4 justify-content-between ${className}`}>
        <div className="mb-3">
          <h1 className="mb-3">
            Build Your Program
          </h1>
          <p className="mb-3">
            Explore our innovative programs: Choose the AI-Powered option to create a
            personalized plan tailored just for you, or grow with our Human-Led Program to
            connect with a dedicated coach who will guide you on your journey.
          </p>
        </div>
      </div>
    </section>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

Header.defaultProps = {
  className: '',
};
